import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LoginService } from './login-service/login.service';
import { environment } from '../../environments/environment';

export const authGuard: CanActivateFn = (_route, _state) => {
	const loginService = inject(LoginService);
	const router = inject(Router);

	// Check if service mode is enabled - if so, redirect to login screen
	if (environment.serviceMode) {
		router.navigate(['/login']);
		return false;
	}

	// Check if user is logged in by checking if there's a current user
	const currentUser = loginService.GetCurrentUser();

	if (currentUser) {
		return true;
	} else {
		// Redirect to login page
		router.navigate(['/login']);
		return false;
	}
};
